import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import { useSmartBackButton } from '@/hooks/useSmartBackButton';
import { MainProgressBar } from './MainProgressBar';
import bunoLogo from '@/assets/logo_buno_plus.svg';

export function Header() {
  const { shouldShow, handleBack } = useSmartBackButton();
  const location = useLocation();
  
  // Check if current path is a quote view (matches pattern /:quoteId where quoteId is not a standard route)
  const standardRoutes = ['introduccion', 'eleccion', 'variant-tester', 'shopify-tester'];
  const pathSegment = location.pathname.slice(1); // Remove leading slash
  const isCotizacion = pathSegment && !standardRoutes.includes(pathSegment) && !pathSegment.startsWith('eleccion/') && !pathSegment.startsWith('snapshot/');
  
  const isEleccionFlow = (location.pathname.startsWith('/eleccion/') || isCotizacion);
  const isCarrito = location.pathname == '/eleccion/carrito';
  const carritoOrCotizacion = isCarrito || isCotizacion;

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
      <div className="container h-fit min-h-20 px-4 flex justify-center items-center">
        {shouldShow && !carritoOrCotizacion && (
          <Button
            variant="ghost"
            size="icon"
            onClick={handleBack}
            className="h-10 w-10 rounded-full"
            aria-label="Go back"
          >
            <ChevronLeft style={{ width: '1.25rem', height: '1.25rem', strokeWidth: '3px'}}/>
          </Button>
        )}
        
        <div className="flex-1 flex justify-center">
          {isEleccionFlow ? (
            (carritoOrCotizacion) ? <><h1 className="text-2xl font-bold text-foreground -mt-6 sm:mt-0" style={ !isCotizacion ? {marginTop: "0px"} : {}}>{isCotizacion ? 'Cotización' : 'Carrito'}</h1></> : <><MainProgressBar /></>
          ) : (
            <Link to="/" className="flex items-center space-x-2">
              <img 
                src={bunoLogo} 
                alt="buno+ logo" 
                className="h-6 w-auto"
              />
            </Link>
          )}
        </div>
        {shouldShow && !carritoOrCotizacion && (
        <div className="w-10"></div>)}
      </div>
    </header>
  );
}